import client from 'lib/api/client';

export async function getVodInfo({titleNo, mode}: IGetVodInfo) {
  const response = await client.get<IVodInfoData>(
    `/vodeditor/api/vodInfo.php?titleNo=${titleNo}&mode=${mode}`,
  );
  return response.data;
}

export interface IGetVodInfo {
  titleNo: number;
  mode: string;
}

export interface IVodInfoData {
  result: number;
  message: string;
  response: Response;
}

export interface Response {
  info: Info;
  files?: FileEntity[] | null;
}
export interface Info {
  title_no: number;
  broad_no: number;
  title_name: string;
  user_nick: string;
  user_id: string;
  grade: number;
  thumb: string;
  flag: string;
  file_type: string;
  hashtags: string;
  read_cnt: string;
  region_type: number;
  chat_url: string;
  snapshot_url: string;
  subscription_personalcon?: null[] | null;
  total_duration: number;
  total_duration_ms: number;
  login_id: string;
  login_nick: string;
  note_cnt: number;
  chat_duration: number;
  resolution: string;
  bbs?: Ibbs[] | null | undefined;
  auth_no: number;
  langs: {
    [key: string]: string;
  };
}

export interface Ibbs {
  bbs_no: number;
  name: string;
}

export interface FileEntity {
  file_idx: number;
  grade: number;
  hide: string;
  file_start: string;
  duration: number;
  duration_ms: number;
  file_path: string;
  file_size: number;
  file_order: number;
  file_info_key: string;
  vod_url: string;
}

// export const vodInfo = (titleNo: number) =>
//     client.post("/vodeditor/api/cut_edit.php", { titleNo });
